import { React, useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    document.title = "My Awesome Website";
  }, []);

  return (
    <div className="container">
      <h1>Welcome to Koushal's Website</h1>
      <button className="btn">Get Started</button>
    </div>
  );
}

export default App;
